import common from './common.json';
import ho from './ho.json';
import obx from './obx.json';
import sales from './sales.json';

const de = {
  ...common,
  obx,
  ho,
  sales,
};

export default de;
